/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('BlockAction.mob.title') }} </h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container mob-help">

        <h1>Covoiturage solidaire</h1>
        <p>Faire jouer la solidarité pour trouver un covoiturage</p>

        <div class="">
        <ion-button
          class="mc-big-button"
          color="secondary"
          expand="block"
          @click="redirectToSolidarity()"
        >
          {{ $t(`BlockAction.solidarity.button`)}}
        </ion-button>

        <ion-button
          class="mc-big-button"
          color="secondary"
          expand="block"
          fill="outline"
          @click="redirectToSolidarityPost()"
        >
          {{ $t(`BlockAction.solidarity.secondButton`)}}
        </ion-button>
        </div>

        <br>
        <h1>Dispositif d'aide, avec moB</h1>
        <p><b>moB</b> {{ $t('Prime.help') }}</p>
        <p>Consultez les aides auxquelles vous avez droit (accompagnement à la mobilité, aide à l'achat de véhicules, remboursement de frais de déplacements ...)</p>
        <p>Pour consulter les aides :</p>

        <div v-if="!user">
          <ion-button
            class="mc-big-button"
            color="secondary"
            expand="block"
            @click="redirectToLogin()"
          >
            Connexion
          </ion-button>

          <!--
          <ion-button
            class="mc-big-button"
            color="secondary"
            expand="block"
            fill="outline"
            @click="redirectToRegister()"
          >
            Inscription
          </ion-button>
          -->
        </div>

        <div v-if="user">
          <ion-button
            class="mc-big-button"
            v-if="!isMob"
            color="secondary"
            expand="block"
            @click="mobConnect()"
          >
            Activer le service moB
          </ion-button>

          <ion-button
            class="mc-big-button"
            color="secondary"
            expand="block"
            v-if="isMob"
            @click="redirectToHelp()"
          >
            Consulter les aides
          </ion-button>
        </div>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">




</style>

<script>
  import {toast} from "../../Shared/Mixin/toast.mixin";
  import {required, minLength} from '@vuelidate/validators';
  import { address } from '../../Shared/Mixin/address.mixin';
  import Compressor from 'compressorjs';
  import {isPlatform} from "@ionic/core";
  import store from "../../Shared/Store/store";
  import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser';

  export default {
    name: 'prime',
    data () {
      return {
        isMob: false,
        solidaryLink: process.env.VUE_APP_SOLIDARITY_LINK,
      }
    },
    mixins: [toast, address],
    props : [],
    created() {
      if (this.user.hasAccessToMobAPI) {
        this.isMob = true
      }
    },
    computed: {
      user: {
        get() {
          return this.$store.state.userStore.user;
        }
      },
    },
    methods: {
      redirectToSolidarity: function() {
        if (this.solidaryLink =="") {
          this.$router.push({ name: "carpool.solidary.home.request" });
        } else {
          this.$router.push({ name: "carpool-solidarity" });
        }
      },

      redirectToSolidarityPost: function() {
        this.$router.push({ name: "post-carpool", params: { solidarity: true } });
      },

      redirectToLogin: function() {
        this.$store.commit('redirectionUrl_change', {name: 'mob-help'});
        this.$router.push({ name: "login" });
      },

      redirectToHelp: function() {
        this.$router.push({ name: "incentives" });
        /*
        let uri = 'https://moncomptemobilite.fr/recherche'
        if (isPlatform(window.document.defaultView, "capacitor")) {
          InAppBrowser.create(uri, '_system');
        } else {
          window.open(uri, '_self');
        }
         */
      },


      mobConnect() {
        // window.open('https://idp.preprod.moncomptemobilite.fr/auth/realms/mcm/protocol/openid-connect/auth?client_id=mobicoop_pub&redirect_uri=https://test.mobicoop.io/user/sso/eec-incentive/user/sso/login&state=mobConnect-test&response_mode=fragment&response_type=code&scope=openid&nonce=21a8befa-b65f-41c5-916b-29c9e8d70177', '_system');
        this.$store.commit('redirectionUrl_change', {name: 'mob-help'});
        this.$store.dispatch('sso_connections', {eec: false}).then((res) => {
          if (res && res.length > 0) {
            let uri = res.find(item => item.ssoProvider === 'mobConnectBasic').uri;
            // uri = uri.replace('#', '%23').replace('/eec-incentive' , '/eec-incentive?mobicoop=true' ).replace('response_mode=query', 'response_mode=fragment' )  ;
            if (isPlatform(window.document.defaultView, "capacitor")) {
              InAppBrowser.create(uri, '_system');
            } else {
              window.open(uri, '_self');
            }
          }
        }).catch((error) => {
          console.log(error)
          this.presentToast(this.$t("Commons.error"), "danger");
        })
      },
    }
  }
</script>
